import React, {PropTypes} from "react";
import Modal from "react-bootstrap/lib/Modal";
import CheckBox from "material-ui/Checkbox";
import TextField from "material-ui/TextField";
import axios from "axios";
import toastr from "toastr";

class RequestModal extends React.Component {

  constructor(props) {
    super(props);
    this.state = {remarks: "", ownerEmpName: "", verticalHeadName : "", disableBtn : 0};
    this.requestAccessAPI = this.requestAccessAPI.bind(this);
  }

  componentDidMount() {
    axios.get(process.env.REQ_URL + "/aboutEmp?q=" + this.props.applicationSelected.ownerEmpId, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.setState({ownerEmpName: response.data.data.name});
    }).catch((err)=> {
    });

    axios.get(process.env.REQ_URL + "/aboutEmp?q=" + this.props.verticalHead, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.setState({verticalHeadName: response.data.data.name});
    }).catch((err)=> {
    });
  }

  requestAccessAPI(data, recovery) {
    //Make the post API CALL and if ERROR OCCURS DISPLAY TOAST MESSAGE
    //IF SUCCESS , CLOSE MODAL and REFRESH MY PENDING APPLICATIONS AND MY APPLICATIONS
    this.setState({disableBtn: 1});
    console.log(this.props);

    let request = {
      "approvedMgrEmpID": this.props.reportingTo,
      "empComments": this.state.remarks,
      "createdBy": this.props.empID,
      "empID": this.props.empID,
      "appID": this.props.applicationSelected.id,
      "ownerApprovedEmpID": this.props.applicationSelected.ownerEmpId,
      "approvedVhEmpID": this.props.verticalHead,
    }
    console.log(request);
    axios.post(process.env.REQ_URL + "/appaccess/saveApplicationAccess", {data: request}, {withCredentials: true , headers: {'X-Requested-With': 'XMLHttpRequest'}}).then((response)=> {
      this.props.close();
      this.props.refresh();
      toastr.success("Data updated")

    }).catch((err)=> {
      toastr.error("Error While applying");
    });
  }

  render() {
    console.log("MODEL OPEN");
    console.log(this.props.applicationSelected);
    let vhDetails;
    if(this.props.applicationSelected.vhPermission==1){
       vhDetails = <p>Vertical Head Name: {this.state.verticalHeadName} ({this.props.verticalHead})</p>
    }
    return (
      <Modal
        bsSize="small"
        show={this.props.open} onHide={this.props.close}>
        <Modal.Header closeButton>
          <Modal.Title>Request Access</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Application Name: {this.props.applicationSelected.appName}</p>
          <p>Manager Name: {this.props.reportingToName} ({this.props.reportingTo})</p>
          {vhDetails}
          <p>Application Owner Name: {this.state.ownerEmpName} ({this.props.applicationSelected.ownerEmpId})</p>
          <TextField
            hintText="Enter Comments"
            errorText={this.state.errorText}
            floatingLabelText="Remarks"
            value={this.state.remarks}
            onKeyPress = {(target) => {if(target.charCode==13) $("#saveButton").click();}}
            onChange={(event)=> {

              this.setState({remarks: event.target.value,errorText: ""})
            }
            }/>
          <br/>
          <button
            id = "saveButton"
            disabled={this.state.remarks.length==0 || this.state.disableBtn == 1?true:false}
            onClick={this.requestAccessAPI}
            className="btn btn-default btn-block">Save
          </button>
          &nbsp;
        </Modal.Body>
      </Modal>
    );
  }
}

RequestModal.propTypes = {};

export default RequestModal;



/** WEBPACK FOOTER **
 ** ./src/feature/appAccess/MyApplications/components/RequestModal.js
 **/